module.exports = __webpack_public_path__ + "img/sparkly_btc.82b61d74.svg";